var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"multi-slide-marquee",style:(_vm.styles)},_vm._l((_vm.slides),function(slide){return _c(slide.componentName,{key:slide.id,tag:"component",attrs:{"slide":slide},on:{"background-reveal":_vm.onBackgroundReveal}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }